import { render } from "./RevolutionFund.vue?vue&type=template&id=1ccdf936"
import script from "./RevolutionFund.vue?vue&type=script&lang=js"
export * from "./RevolutionFund.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__